import React, { memo } from 'react';
import t from 'common/i18n';
import Checkbox from 'root/components/Checkbox/Checkbox';
import DropdownList from 'root/components/DropdownList/DropdownList';

export const IMAGE_TYPES = ['all', 'photo', 'illustration', 'vector'];

const MoreFilters = (props) => {
  const { filters, categories, onChange } = props;

  const typesItems = IMAGE_TYPES.map((value) => ({ label: t(`shutterstock.filters.types.${value}`), value }));
  const selectedType = typesItems.find((ti) => ti.value === filters.type);

  return (
    <section>
      <label>{t('shutterstock.filters.more_label')}</label>

      {props.mediaType === 'images' && (
        <DropdownList className="mb5" items={typesItems} selectedItem={selectedType} onChange={(item) => onChange({ type: item.value })} placement="top" />
      )}

      <div className="flex items-center checkbox-wrapper  mb5">
        <Checkbox
          className="flex-shrink-0 pointer mr5"
          checked={filters.safe}
          borderWidth={2}
          borderRadius={2}
          size={16}
          activeThemeColor="link"
          onClick={() => onChange({ safe: !filters.safe })}
        />
        <div>{t('shutterstock.filters.safe')}</div>
      </div>
      {categories.length && (
        <DropdownList
          className="mb5"
          items={props.categories}
          selectedItem={categories.find((item) => item.value === filters.category)}
          onChange={(item) => onChange({ category: item.value })}
          placement="top"
        />
      )}
    </section>
  );
};

export default memo(MoreFilters);
